var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.0001C21.0523 15.0001 21.5 15.4478 21.5 16.0001V20.0001C21.5 21.1047 20.6046 22.0001 19.5 22.0001H5.5C4.39543 22.0001 3.5 21.1047 3.5 20.0001V16.0001C3.5 15.4478 3.94772 15.0001 4.5 15.0001C5.05228 15.0001 5.5 15.4478 5.5 16.0001V20.0001H19.5V16.0001C19.5 15.4478 19.9477 15.0001 20.5 15.0001ZM13.3839 3.47451L17.4497 7.54038C17.8403 7.9309 17.8403 8.56407 17.4497 8.95459C17.0592 9.34511 16.4261 9.34511 16.0355 8.95459L13.5 6.41906V16.0001C13.5 16.5524 13.0523 17.0001 12.5 17.0001C11.9477 17.0001 11.5 16.5524 11.5 16.0001V6.41906L8.96447 8.95459C8.57394 9.34511 7.94078 9.34511 7.55025 8.95459C7.15973 8.56407 7.15973 7.9309 7.55025 7.54038L11.6161 3.47451C12.1043 2.98636 12.8957 2.98636 13.3839 3.47451Z",
    fill: "#116F9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2Line);
export default __webpack_public_path__ + "static/media/upload_2_line.169cc4baf87e85d7c26d432a81c3cd42.svg";
export { ForwardRef as ReactComponent };